import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import alumniDayService from "./alumniDayService"

const initialState = {
    days: [],
    isLoading: false,
    isError: false,
    currentPage: 1,
    lastPage: 1,
    perPage: 16,
    alumniDayDetails: {},
    nextPageURI: null,
    prevPageURI: null,
    pageContent: {},
}

export const fetchDays = createAsyncThunk(
    "alumniDay/fetchDays",
    async (currentPage, thunkAPI) => {
        try {
            const { getState } = thunkAPI
            const state = getState().alumniDayPage
            return await alumniDayService.fetchDays(state.perPage, currentPage)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchPageContent = createAsyncThunk(
    "alumniDay/fetchPageContent",
    async (slug, thunkAPI) => {
        try {
            return await alumniDayService.fetchPageContent(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchAlumniDayDetails = createAsyncThunk(
    "alumniDay/fetchAlumniDayDetails",
    async (slug, thunkAPI) => {
        try {
            return await alumniDayService.fetchAlumniDayDetails(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const alumniDaySlice = createSlice({
    name: "alumniDay",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDays.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchDays.fulfilled, (state, action) => {
                state.isLoading = false
                state.days = [...state.days, ...action.payload.data]
                state.currentPage = action.payload.current_page
                state.lastPage = action.payload.last_page
                state.nextPageURI = action.payload.next_page_url
                state.prevPageURI = action.payload.prev_page_url
            })
            .addCase(fetchDays.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.days = []
                state.currentPage = 1
                state.lastPage = 1
                state.nextPageURI = null
                state.prevPageURI = null
                state.errorMessage = action.payload
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.pageContent = action.payload
            })
            .addCase(fetchPageContent.rejected, (state) => {
                state.pageContent = {}
            })
            .addCase(fetchAlumniDayDetails.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchAlumniDayDetails.fulfilled, (state, action) => {
                state.isLoading = false
                state.alumniDayDetails = action.payload
            })
            .addCase(fetchAlumniDayDetails.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.errorMessage = action.payload
            })
    },
})

export default alumniDaySlice.reducer
